import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

import { AuthStore } from './types';
import { createStateSlice } from './slices/state';
import { createFunctionsSlice } from './slices/functions';
import { createProfileSlice } from './slices/profile';
import { createAuxSlice } from './slices/auxiliares';
import { createUtilsSlice } from './slices/utils';

const useAuth = create<AuthStore>()(
    persist(
        (...args) => ({
            ...createStateSlice(...args),
            ...createFunctionsSlice(...args),
            ...createProfileSlice(...args),
            ...createAuxSlice(...args),
            ...createUtilsSlice(...args),
        }),
        {
            name: 'current-login',
            storage: createJSONStorage(() => localStorage),
            partialize: (state) => ({ data: state.data, superAdminView: state.superAdminView }),
            onRehydrateStorage: () => (state) => {
                if (state?.data?.tokenData?.accessToken) {
                    localStorage.setItem('token', state.data.tokenData.accessToken);
                }
            },
        }
    )
);

export default useAuth;

export * from './types';
